export default "__VITE_ASSET__128e0c0a__"